import { selectedSite } from "./model.js";
import { S } from "../../app/store.js";
import { esc } from "../../domain/format.js";

function sitePicker() {
  return `<label class="site-picker"><span>Site / location</span><select id="site-select"><option value="ALL"${selectedSite() === "ALL" ? " selected" : ""}>ALL · Consolidated</option><option value=""${selectedSite() === "" ? " selected" : ""}>Head office / unassigned</option>${S.sites.map((p) => `<option value="${esc(p.id)}"${selectedSite() === p.id ? " selected" : ""}>${esc(p.code)} · ${esc(p.name)}</option>`).join("")}</select></label>`;
}

export { sitePicker };
